import { CheckIcon } from "@/react/components/SettingsApp/Plan/RegularPlan/CheckIcon";
import { Icon } from "@/react/components/shared/Icon";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface PlanFeatureProps {
  isHighlighted: boolean;
  feature: string;
  color?: string;
  highlightColor?: string;
  LabelComponent?: React.ElementType;
}

export const PlanFeature = ({
  feature,
  isHighlighted,
  color = "text-slate-700 dark:text-slate-300",
  highlightColor = "text-blue-highlight",
  LabelComponent = Typography.BodySm,
}: PlanFeatureProps) => (
  <div key={feature} className="flex flex-row items-start gap-1">
    {isHighlighted ? (
      <Icon
        type="16-star-fill"
        size={16}
        className={classNames("mr-1", isHighlighted ? highlightColor : "")}
        useWithFillCurrentColor
        useWithStrokeCurrentColor
      />
    ) : (
      <CheckIcon />
    )}
    <LabelComponent color={color} key={feature}>
      {feature}
    </LabelComponent>
  </div>
);
